import { cn } from '@/lib/utils';

interface SkeletonProps {
  className?: string;
  variant?: 'text' | 'circular' | 'rectangular';
  width?: string | number;
  height?: string | number;
}

export function Skeleton({ className, variant = 'rectangular', width, height }: SkeletonProps) {
  const baseStyles = 'animate-pulse bg-slate-200 rounded';
  
  const variantStyles = {
    text: 'h-4',
    circular: 'rounded-full',
    rectangular: 'rounded-2xl',
  };

  const style: React.CSSProperties = {};
  if (width) style.width = typeof width === 'number' ? `${width}px` : width;
  if (height) style.height = typeof height === 'number' ? `${height}px` : height;

  return (
    <div
      className={cn(baseStyles, variantStyles[variant], className)}
      style={style}
      aria-busy="true"
      aria-live="polite"
    />
  );
}

export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <div className={cn('space-y-2', className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          variant="text"
          width={i === lines - 1 ? '75%' : '100%'}
          className="h-4"
        />
      ))}
    </div>
  );
}

export function ProductCardSkeleton() {
  return (
    <div className="glass-panel space-y-4 p-6">
      <div className="flex items-center gap-4">
        <Skeleton variant="rectangular" width={64} height={64} className="rounded-2xl" />
        <div className="flex-1 space-y-2">
          <Skeleton variant="text" width="60%" className="h-5" />
          <Skeleton variant="text" width="40%" className="h-3" />
        </div>
      </div>
      <div className="flex gap-2">
        <Skeleton variant="rectangular" width={80} height={32} className="rounded-2xl" />
        <Skeleton variant="rectangular" width={100} height={32} className="rounded-2xl" />
      </div>
    </div>
  );
}

export function TableRowSkeleton({ columns = 4 }: { columns?: number }) {
  return (
    <tr className="hover:bg-slate-50/80">
      {Array.from({ length: columns }).map((_, i) => (
        <td key={i} className="px-4 py-4">
          <Skeleton variant="text" width={i === 0 ? '80%' : '60%'} className="h-4" />
        </td>
      ))}
    </tr>
  );
}




